import { defineMessages } from 'react-intl';

export const objectReferenceMetadataMessages = defineMessages({
  lastSeen: {
    id: 'iJSWYVqR+N',
    defaultMessage: 'Last seen {date}',
    description: 'Object preview metadata: the date a patient was last seen',
  },
  lastEdited: {
    id: 'IuWQwjbZmR',
    defaultMessage: 'Edited {date}',
    description: 'Object preview metadata: the date a template was last edited',
  },
  sessionCount: {
    id: 'DJGK4D372B',
    defaultMessage: '{count, plural, one {# session} other {# sessions}}',
    description: 'Object preview metadata: how many sessions a patient has',
  },
  timesUsed: {
    id: 'd9pLRuAv5F',
    defaultMessage: '{count, plural, one {# use} other {# uses}}',
    description: 'Object preview metadata: how many times a template has been used',
  },
  noPatientLinked: {
    id: '9ItnuXqbEi',
    defaultMessage: 'No patient linked',
    description: 'Object preview metadata: the session is not linked to a patient',
  },
  ownerPersonal: {
    id: 'wJqXp+/fHX',
    defaultMessage: 'Personal',
    description: 'Object preview metadata: the template belongs to the user',
  },
  ownerTeam: {
    id: 'sIBVrsledO',
    defaultMessage: 'Team',
    description: "Object preview metadata: the template belongs to the user's team",
  },
  ownerCommunity: {
    id: '4lZusgmbls',
    defaultMessage: 'Community',
    description: 'Object preview metadata: the template comes from the community',
  },
  sourceGeneratedByHeidi: {
    id: 'izmnW+NA2F',
    defaultMessage: 'Created by Heidi',
    description: 'Object preview metadata: the document was created by Heidi',
  },
  linkedTo: {
    id: 'ZJLm6Tx7RT',
    defaultMessage: 'Linked to {name}',
    description: 'Object preview metadata: the patient the object is linked to',
  },
  taskForPatient: {
    id: 'isjeoqPsXc',
    defaultMessage: 'For {name}',
    description: 'Object preview metadata: the patient a task is for',
  },
  documentCount: {
    id: 'iGfD/Q9Erh',
    defaultMessage: '{count, plural, one {# document} other {# documents}}',
    description: 'Object preview metadata: how many documents a library collection holds',
  },
  taskTodo: {
    id: 'zKx+uKVyZx',
    defaultMessage: 'To do',
    description: 'Object preview metadata: a clinical task has not been started',
  },
  taskInProgress: {
    id: 'CGEXglQ4Ea',
    defaultMessage: 'In progress',
    description: 'Object preview metadata: a clinical task is in progress',
  },
  taskDone: {
    id: 'WvR0MMo5HE',
    defaultMessage: 'Done',
    description: 'Object preview metadata: a clinical task is done',
  },
  taskArchived: {
    id: 'M2TDgwEuz/',
    defaultMessage: 'Archived',
    description: 'Object preview metadata: a clinical task is archived',
  },
  dueDate: {
    id: 'YLCXTKunnK',
    defaultMessage: 'Due {date}',
    description: 'Object preview metadata: the date a clinical task is due',
  },
  overdue: {
    id: 'LWL18pF313',
    defaultMessage: 'Overdue',
    description: 'Object preview metadata: a clinical task is past its due date',
  },
});
